// Copyright (c) Docugami, Inc. All rights reserved.

import { StatusIcon } from "components/common/StatusIcon";
import styled from "styled-components";
import { ExplorerInfoTextBold } from "./ExplorerStyles";
import { DocSetStatusInfo } from "components/cluster_management/DocSetStatus";
import { DirectionalHint, TooltipHost } from "@fluentui/react";
import { getAutomationIdForDocsetStatus } from "utils/Automation";

const InfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 7px;
`

const InfoTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    width: 100%;
    align-items: center;
    gap: 8px;
`

interface DocSetStatusInfoProps {
    docSetId: string;
    info: DocSetStatusInfo;
}

export const DocSetInfo = (props: DocSetStatusInfoProps): JSX.Element => {
    return (
        <TooltipHost content={props.info.details} directionalHint={DirectionalHint.bottomCenter}>
            <InfoContainer data-automation-id={getAutomationIdForDocsetStatus(props.info.label)}>
                <StatusIcon color={props.info.statusColor} size={14} />
                <InfoTextContainer>
                    <ExplorerInfoTextBold>{props.info.label.toLocaleUpperCase()}</ExplorerInfoTextBold>
                </InfoTextContainer>
            </InfoContainer>
        </TooltipHost>
    )
}
